import axios from "axios";

let url = "";
console.log(
  "window.location.pathname, ",
  extractFirstPart(window.location.href)
);
if (extractFirstPart(window.location.href) == "portal-tps") {
  url = "https://us-central1-portal-tps.cloudfunctions.net";
} else if (extractFirstPart(window.location.href) == "portal") {
  url = "https://us-central1-prod-prepaidplus.cloudfunctions.net";
} else {
  url = "http://127.0.0.1:5001/portal-tps/us-central1";
}

console.log("Axios Firebase URL: ", url);

const instance = axios.create({
  baseURL: url,
});

function extractFirstPart(url) {
  const withoutProtocol = url.split("://")[1];
  const domainPart = withoutProtocol.split("/")[0];
  const firstPart = domainPart.split(".")[0];
  return firstPart;
}

export default instance;
